const VGeos = [
  "row",
  "eu",
  "us"
];
const VRegions = [
  "sg",
  "va",
  "gcp",
  "eu-ttp",
  "eu-ttp2",
  "us-ttp",
  "us-ttp2"
];
const VRegionToVGeoMap = {
  sg: "row",
  va: "row",
  gcp: "eu",
  "eu-ttp": "eu",
  "eu-ttp2": "eu",
  "us-ttp": "us",
  "us-ttp2": "us"
};
const BoeVRegions = [
  "cn-boe",
  "i18n-boe",
  "ttp-boe"
];
const RegionsResources = {
  vgeos: VGeos,
  vregions: VRegions,
  vregionToVGeoMap: VRegionToVGeoMap,
  boeVRegions: BoeVRegions
};
export {
  BoeVRegions,
  RegionsResources,
  VGeos,
  VRegionToVGeoMap,
  VRegions
};

//# sourceMappingURL=regions.js.map